import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
`;

export const PaymentButton = styled.div`
  background: var(--primary);
  font-weight: 600;
  font-family: Inter;
  font-size: 0.9rem;
  padding: 0.65rem 1.5rem;
  width: 20rem;
  border-radius: 4px;
  transition: all 0.3s;
  color: var(--black-200);
  cursor: pointer;

  &:disabled {
    background: var(--grey-200);
    color: black;
    cursor: default;
  }

  &:hover:enabled {
    opacity: 0.7;
  }
`;

export const PaymentInput = styled.div`
  background-color: transparent;
  height: 2rem;
  width: 15rem;
  border-radius: 10px;
  padding: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--white);
  margin-top: 0.25rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

export const PaymentModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-right: auto;
  padding: 1rem;
`;

export const CommentsSection = styled.div`
  .comments-container {
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);
    margin-bottom: 1rem;
  }

  .date {
    font-size: 16px;
    margin-bottom: 1rem;
  }

  .autor {
    color: var(--primary);
    margin-right: 1rem;
  }

  .content {
    margin-bottom: 1rem;
  }
`;

export const OnTime = styled.h3`
  font-size: 0.85rem !important;
  padding: 0.5625rem 0.75rem;
  border-radius: 6.25rem !important;
  color: var(--green);
  background: rgba(71, 212, 68, 0.1);
  border-radius: 8px;
  text-align: center;
`;

export const IsLate = styled.h3`
  font-size: 0.85rem !important;
  padding: 0.5625rem 0.75rem;
  border-radius: 6.25rem !important;
  color: var(--red);
  background-color: rgba(204, 57, 57, 0.16);
  border-radius: 8px;
  text-align: center;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: row;

  div {
    width: 250px;
  }

  p {
    font-size: 14px;
    color: #b8b8b8;
  }

  h3 {
    font-size: 16px;
    margin-top: 4px;
  }

  li {
    list-style-type: none;
    margin-top: 0.5rem;
  }

  .with-margin {
    margin-top: 1rem;
  }
`;

export const Row = styled.div`
  .comment {
    font-size: 16px;
    margin-top: 1rem;
  }

  & + & {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid rgba(82, 82, 82, 0.64);
  }

  h2 {
    font-size: 16px;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    img {
      margin-right: 1rem;
    }
  }
`;

export const Distance = styled.span`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--white);
  text-decoration: underline;
  text-decoration: none;
`;
